import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

const highlights = [
  "TS EN ISO 9001:2015 sertifikalı üretim tesisi",
  "Yüksek karbonlu çelik & galvaniz kaplama uzmanlığı",
  "Anadolu'nun 81 ilinde hızlı sevkiyat ağı",
  "Mühendis kadrosu ile özel ölçü ve gramaj üretimi",
];

export default function About() {
  return (
    <section
      id="hakkimizda"
      data-testid="about-section"
      className="relative bg-white py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-6 relative"
          >
            <div className="aspect-[4/5] w-full overflow-hidden rounded-[2rem] bg-gray-100 shadow-[0_30px_60px_-25px_rgba(0,0,0,0.2)]">
              <img
                src="https://customer-assets.emergentagent.com/job_telecom-pro-6/artifacts/7sv46fjn_IMG-20260610-WA0004.jpg"
                alt="İnci Tel çit ve kapı uygulamaları"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-5 -right-3 sm:-right-6 bg-[#FF5A00] text-white px-7 py-5 rounded-2xl shadow-[0_20px_40px_-15px_rgba(255,90,0,0.5)]">
              <div className="font-mono-disp text-[10px] uppercase tracking-wider text-white/85">
                Kuruluş yılı
              </div>
              <div className="font-display text-5xl font-bold mt-1 tracking-tight leading-none">
                1998
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="lg:col-span-6"
          >
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#FF5A00]/10 text-[#FF5A00] font-mono-disp text-[11px] font-medium">
              <span className="w-1.5 h-1.5 rounded-full bg-[#FF5A00]" />
              Hakkımızda
            </div>
            <h2 className="font-display mt-5 text-4xl sm:text-5xl md:text-6xl font-semibold tracking-tighter text-gray-900 leading-[1.02]">
              Çeyrek asırdır tel ve{" "}
              <span className="font-serif-disp font-normal text-[#FF5A00]">
                çit
              </span>{" "}
              sektöründeyiz.
            </h2>
            <p className="font-body mt-6 text-base sm:text-lg text-gray-600 leading-relaxed">
              İnci Tel Çit Sistemleri, 1998 yılında İstanbul&apos;da kurulmuş olup
              galvanizli tel, bakır tel, örgü tel ve dikenli tel üretiminde
              Türkiye&apos;nin güvenilir markaları arasındadır. Modern üretim
              hatları, deneyimli mühendislik ekibi ve tam otomasyon destekli
              kalite kontrol süreçleri ile endüstriyel standartlarda çözümler
              sunarız.
            </p>

            <ul className="mt-8 space-y-3">
              {highlights.map((h) => (
                <li key={h} className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-[#FF5A00] flex-shrink-0 mt-0.5" />
                  <span className="font-body text-sm sm:text-base text-gray-700">
                    {h}
                  </span>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
